import ServicePropertySchema from '../schemas/ServicePropertySchema'

export default function ServicePropertyVo(initData = {}) {
  return ServicePropertySchema.validateSync(initData)
}
